var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddAPhoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3884_23764",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#67748E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3884_23764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.666 18.6667V13.3334H45.3327V8.00008H50.666V2.66675H55.9994V8.00008H61.3327V13.3334H55.9994V18.6667H50.666ZM29.3327 46.6667C32.666 46.6667 35.4994 45.5001 37.8327 43.1667C40.166 40.8334 41.3327 38.0001 41.3327 34.6667C41.3327 31.3334 40.166 28.5001 37.8327 26.1667C35.4994 23.8334 32.666 22.6667 29.3327 22.6667C25.9993 22.6667 23.166 23.8334 20.8327 26.1667C18.4993 28.5001 17.3327 31.3334 17.3327 34.6667C17.3327 38.0001 18.4993 40.8334 20.8327 43.1667C23.166 45.5001 25.9993 46.6667 29.3327 46.6667ZM29.3327 41.3334C27.466 41.3334 25.8882 40.689 24.5993 39.4001C23.3105 38.1112 22.666 36.5334 22.666 34.6667C22.666 32.8001 23.3105 31.2223 24.5993 29.9334C25.8882 28.6445 27.466 28.0001 29.3327 28.0001C31.1994 28.0001 32.7771 28.6445 34.066 29.9334C35.3549 31.2223 35.9994 32.8001 35.9994 34.6667C35.9994 36.5334 35.3549 38.1112 34.066 39.4001C32.7771 40.689 31.1994 41.3334 29.3327 41.3334ZM7.99935 56.0001C6.53268 56.0001 5.27713 55.4779 4.23268 54.4334C3.18824 53.389 2.66602 52.1334 2.66602 50.6667V18.6667C2.66602 17.2001 3.18824 15.9445 4.23268 14.9001C5.27713 13.8556 6.53268 13.3334 7.99935 13.3334H16.3993L21.3327 8.00008H39.9994V18.6667H45.3327V24.0001H55.9994V50.6667C55.9994 52.1334 55.4771 53.389 54.4327 54.4334C53.3882 55.4779 52.1327 56.0001 50.666 56.0001H7.99935Z",
    fill: "#67748E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAPhoto);
export default __webpack_public_path__ + "static/media/add_a_photo.a548553139c9c336291b6bfd4c461ea5.svg";
export { ForwardRef as ReactComponent };